import React, { useEffect, useState } from "react";
import { authFetch } from "../../api";

const inputClass = "w-full px-4 py-2 rounded-lg bg-white/5 border border-navy-border text-white focus:outline-none focus:border-accent-light";

export default function BrowserTitleSettings() {
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    authFetch("/core/hero/home/")
      .then((res) => res.json())
      .then(setData)
      .catch(() => setError("Failed to load this page's content."));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      const res = await authFetch("/core/hero/home/", {
        method: "PATCH",
        body: JSON.stringify({ page_title: data.page_title, tagline: data.tagline }),
      });
      if (!res.ok) throw new Error();
      setMessage("Browser title updated.");
    } catch {
      setError("Failed to save.");
    }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold mb-1">Browser Title</h1>
      <p className="text-sm text-gray-400 mb-6">
        Controls the Home page's browser tab title, shown as "Title - Tagline". The Hero visual itself is managed
        under Home Banner.
      </p>

      {error && <p className="text-sm text-red-400 mb-4">{error}</p>}

      {!data ? (
        <p className="text-gray-400">Loading...</p>
      ) : (
        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-300 mb-1">Title</label>
            <input
              className={inputClass}
              value={data.page_title}
              onChange={(e) => setData({ ...data, page_title: e.target.value })}
              placeholder="Home"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-300 mb-1">Tagline</label>
            <input
              className={inputClass}
              value={data.tagline}
              onChange={(e) => setData({ ...data, tagline: e.target.value })}
            />
          </div>
          {message && <p className="text-sm text-green-400">{message}</p>}
          <button className="px-6 py-2 rounded-lg bg-brand-gradient text-white font-semibold">
            Save Changes
          </button>
        </form>
      )}
    </div>
  );
}
